export enum DrayageCargoActionTypes {
  SET_PACKING_LIST_DOCUMENT_KEY = "SET_PACKING_LIST_DOCUMENT_KEY",
  SET_PACKING_LIST_FILE_NAME = "SET_PACKING_LIST_FILE_NAME",
}
